import { render, staticRenderFns } from "./Comunicados.vue?vue&type=template&id=7a35ef7a&scoped=true&"
import script from "./Comunicados.vue?vue&type=script&lang=js&"
export * from "./Comunicados.vue?vue&type=script&lang=js&"
import style0 from "./Comunicados.vue?vue&type=style&index=0&id=7a35ef7a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a35ef7a",
  null
  
)

export default component.exports